import RichTextInput from "ra-input-rich-text";
import {
  Create,
  CreateProps,
  FileField,
  FileInput,
  FormTab,
  ImageField,
  ImageInput,
  required,
  SelectInput,
  TabbedForm,
  TextInput,
} from "react-admin";
import { AccessRestriction, PublicationStatus } from "../Media.enum";
import MediaTitle from "../MediaTitle";
import { Grid } from "@material-ui/core";
import { rowStyles, videoMsgStyle } from "../MediaListStyle";

const validateRequired = [required()];

const MediaCreate = (props: CreateProps) => {
  const classes = rowStyles();
  const videoMsgClasse = videoMsgStyle();

  // const theResource = useResourceContext();
  // console.log(theResource);
  // const checkTag = async (
  //   e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  // ) => {
  //   const res = await dataProvider.checkTag(e);
  //   console.log(props);
  //   return res;
  // };
  return (
    <Create title={<MediaTitle />} {...props}>
      <TabbedForm>
        <FormTab label="Summary">
          <TextInput
            label="Titre"
            source="media.title"
            validate={validateRequired}
          />
          <RichTextInput
            label="description"
            source="media.description"
            toolbar={[
              ["bold", "italic", "underline", "strike"], // toggled buttons
              ["blockquote", "link"],

              // [{ header: 1 }, { header: 2 }], // custom button values
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }], // superscript/subscript
              [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
              [{ direction: "rtl" }], // text direction

              [{ size: ["small", false, "large", "huge"] }], // custom dropdown
              // [{ header: [1, 2, 3, 4, 5, 6, false] }],

              [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              [{ font: [] }],
              [{ align: [] }],

              ["clean"],
            ]}
            validate={validateRequired}
          />
          {props.resource !== "Vod" && (
            <SelectInput
              label="Acces restriction"
              source="media.accessRestriction"
              choices={[
                { id: AccessRestriction.PUBLIC, name: "Public" },
                {
                  id: AccessRestriction.MEMBER_PREMIUM,
                  name: "Membre Premium",
                },
              ]}
              initialValue={AccessRestriction.PUBLIC}
              validate={validateRequired}
            />
          )}
          {props.resource === "Vod" && (
            <TextInput label="Prix" source="purchasePrice" />
          )}
          <SelectInput
            label="Status"
            source="media.publicationStatus"
            choices={[
              { id: PublicationStatus.DRAFT, name: "Brouillon" },
              { id: PublicationStatus.PUBLISHED, name: "Publié" },
            ]}
            initialValue={PublicationStatus.DRAFT}
            validate={validateRequired}
          />
          {props.resource === "Video" && (
            <TextInput
              label="Url Youtube"
              source="youtubeUrl"
            />
          )}
          <TextInput
            label="slug"
            source="media.slug"
            validate={validateRequired}
          />
        </FormTab>
        <FormTab label="Banner">
          <Grid container spacing={2} className={classes.widthAuto}>
            <Grid item xs={6}>
              <ImageInput source="banner" label="Banner" accept="image/*">
                <ImageField source="src" title="current banner" />
              </ImageInput>
            </Grid>
            <Grid item xs={6}>
              <ImageInput
                source="home_banner"
                label="Home Banner"
                accept="image/*"
              >
                <ImageField source="src" title="Home Banner" />
              </ImageInput>
            </Grid>
          </Grid>
        </FormTab>
        {props.resource === "Video" && (
          <FormTab label="Video">
            <hr
              style={{
                border: "none",
                borderBottom: "3px double #ccc",
                margin: "16px 0",
                width: "100%",
              }}
            />

            <div className={videoMsgClasse.videoMsg}>
              Renseignez les informations concertant la video, puis enregistrer,
              vous pourrez ensuite télécharger votre vidéo
            </div>
            <hr
              style={{
                border: "none",
                borderBottom: "3px double #ccc",
                margin: "16px 0",
                width: "100%",
              }}
            />
            <FileInput
              source="srt_input"
              label="Fichier de sous-titres de la vidéo (.srt)"
              accept=".srt"
            >
              <FileField source="src" title="srt" />
            </FileInput>
            <hr
              style={{
                border: "none",
                borderBottom: "3px double #ccc",
                margin: "16px 0",
                width: "100%",
              }}
            />
          </FormTab>
        )}
        {props.resource === "Gallery" && (
          <FormTab label="Gallery">
            <ImageInput
              source="pictures_input"
              label="images"
              multiple={true}
              accept="image/*"
            >
              <ImageField source="src" title="image" />
            </ImageInput>
          </FormTab>
        )}
        {props.resource === "Vod" && (
          <FormTab label="Video">
            <hr
              style={{
                border: "none",
                borderBottom: "3px double #ccc",
                margin: "16px 0",
                width: "100%",
              }}
            />

            <div className={videoMsgClasse.videoMsg}>
              Renseignez les informations concertant la VOD, puis enregistrer,
              vous pourrez ensuite télécharger votre vidéo
            </div>
            <hr
              style={{
                border: "none",
                borderBottom: "3px double #ccc",
                margin: "16px 0",
                width: "100%",
              }}
            />
            <FileInput
              source="srt_input"
              label="Fichier de sous-titres de la vidéo (.srt)"
              accept=".srt"
            >
              <FileField source="src" title="srt" />
            </FileInput>
            <hr
              style={{
                border: "none",
                borderBottom: "3px double #ccc",
                margin: "16px 0",
                width: "100%",
              }}
            />
          </FormTab>
        )}

        <FormTab label="SEO">
          <TextInput
            label="Titre SEO"
            source="media.titleSeo"
            validate={validateRequired}
          />
          <TextInput
            label="description SEO"
            source="media.descriptionSeo"
            validate={validateRequired}
          />
          <TextInput label="keywords SEO" source="media.keywordsSeo" />
        </FormTab>
      </TabbedForm>
    </Create>
  );
};

export default MediaCreate;
